<template>
    <div ref="asset-manager-modal" class="app-modal-dialog app-modal-dialog--asset-manager modal fade page-main" tabindex="-1" role="dialog">
        <div class="app-modal-dialog__content modal-dialog" role="document">
            <div class="app-modal-dialog__header">
                <h2 class="app-modal-dialog__title">Asset Manager</h2>
                <button type="button" class="element-button--icon element-button" data-dismiss="modal" aria-label="Close">
                    <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
                </button>
            </div>
            <div class="app-modal-dialog__body">
                <asset-manager
                    ref="manager"
                    :source="source"
                    :select-mode="true"
                    :auto-load="false"
                    @file-selected="onFileSelected"
                    :max-file-size="maxFileSize"
                    :valid-extensions="validExtensions"
                    :valid-mime-types="validMimeTypes">
                </asset-manager>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
    props: {
        source: {
            type: String
        },
        validExtensions: {
            type: Object,
            default: () => ({ })
        },
        validMimeTypes: {
            type: Object,
            default: () => ({ })
        },
        maxFileSize: {
            type: Number
        }
    },
    methods: {
        onFileSelected (file) {
            $('#asset-manager-modal')
                .trigger('selected', { file })
                .modal('hide')
        }
    },
    mounted () {
        $('#asset-manager-modal').on('show.bs.modal', (e) => {
            this.$store.dispatch('refreshCsrfToken')
        })

        $('#asset-manager-modal').on('hide.bs.modal', (e) => {
            // attempt to pause any running media
            $('audio, video').each((index, media) => {
                media.pause()
            })
        })
    }
}
</script>